<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M2 5H14L13.3333 14H2.66667L2 5Z" stroke="#353B55" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M5.33301 6.33333V2H10.6663V6.33333" stroke="#353B55" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M5.33398 11.333H10.6673" stroke="#353B55" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
